(function () {
  'use strict';

  var root = document.querySelector('.b2b-lead');
  if (!root) return;
  var KEY = root.dataset.klaviyoKey;
  var LIST = root.dataset.klaviyoList;
  var form = root.querySelector('.b2b-lead__form');
  var thanks = root.querySelector('.b2b-lead__thanks');
  var err = root.querySelector('.b2b-lead__error');
  var sizeField = root.querySelector('.b2b-lead__field--size');
  var sizeSelect = sizeField.querySelector('select');
  var sizeLabel = sizeField.querySelector('.b2b-lead__size-label');
  var sticky = root.querySelector('.b2b-lead__sticky');
  var formWrap = root.querySelector('#b2b-richiesta');
  var avviato = false;

  var TIPI = { hotel: 'Hotel, resort, B&B', spa: 'Spa o centro benessere', estetica: 'Centro estetico', farmacia: 'Farmacia o erboristeria', altro: 'Altro' };
  var DIMENSIONI = {
    hotel: ['Quante camere?', ['Fino a 15', 'Da 16 a 60', 'Oltre 60']],
    spa: ['Quante cabine?', ['1 o 2', 'Da 3 a 5', 'Più di 5']],
    estetica: ['Quante cabine?', ['1 o 2', 'Da 3 a 5', 'Più di 5']],
    farmacia: ['Quanti punti vendita?', ['Uno', 'Da 2 a 5', 'Più di 5']]
  };

  function track(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event, form_name: 'richiesta_professionisti' };
    for (var k in extra) payload[k] = extra[k];
    window.dataLayer.push(payload);
  }

  function aggiornaDimensione(tipo) {
    var d = DIMENSIONI[tipo];
    if (!d) { sizeField.hidden = true; sizeSelect.innerHTML = ''; return; }
    sizeLabel.textContent = d[0] + ' (facoltativo)';
    sizeSelect.innerHTML = '<option value="">Scegli</option>' + d[1].map(function (v) { return '<option>' + v + '</option>'; }).join('');
    sizeField.hidden = false;
  }

  function scegliTipo(tipo) {
    var r = form.querySelector('input[name="tipo"][value="' + tipo + '"]');
    if (r) { r.checked = true; aggiornaDimensione(tipo); }
  }

  form.querySelectorAll('input[name="tipo"]').forEach(function (r) {
    r.addEventListener('change', function () { aggiornaDimensione(r.value); });
  });

  root.querySelectorAll('[data-b2b-tipo]').forEach(function (a) {
    a.addEventListener('click', function () {
      scegliTipo(a.dataset.b2bTipo);
      track('b2b_cta_click', { cta_position: 'blocco ' + a.dataset.b2bTipo, business_type: a.dataset.b2bTipo });
    });
  });
  root.querySelectorAll('a[href="#b2b-richiesta"]:not([data-b2b-tipo])').forEach(function (a, i) {
    a.addEventListener('click', function () { track('b2b_cta_click', { cta_position: a.dataset.b2bCta || 'blocco ' + (i + 1) }); });
  });

  form.addEventListener('focusin', function () {
    if (avviato) return;
    avviato = true;
    track('b2b_form_start', {});
  });

  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { sticky.hidden = e[0].isIntersecting; }).observe(formWrap);
  }

  function mostraErrore(msg, campo) {
    err.textContent = msg;
    err.hidden = false;
    if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
  }

  function valida() {
    form.querySelectorAll('[aria-invalid]').forEach(function (c) { c.removeAttribute('aria-invalid'); });
    err.hidden = true;
    if (!form.querySelector('input[name="tipo"]:checked')) { mostraErrore('Scegli che attività hai.'); form.querySelector('input[name="tipo"]').focus(); return false; }
    var obbligatori = [['nome', 'Scrivi il tuo nome e cognome.'], ['attivita', "Scrivi il nome della tua attività."], ['email', "Scrivi la tua email."], ['telefono', 'Scrivi un numero di telefono.'], ['citta', 'Scrivi la città.']];
    for (var i = 0; i < obbligatori.length; i++) {
      var c = form.elements[obbligatori[i][0]];
      if (!c.value.trim()) { mostraErrore(obbligatori[i][1], c); return false; }
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(form.email.value.trim())) { mostraErrore("Sembra che manchi qualcosa nell'indirizzo email.", form.email); return false; }
    if (form.telefono.value.replace(/\D/g, '').length < 6) { mostraErrore('Controlla il numero di telefono.', form.telefono); return false; }
    if (!form.privacy.checked) { mostraErrore("Per ricontattarti ci serve il tuo consenso.", form.privacy); return false; }
    return true;
  }

  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.sito.value) return;
    if (!valida()) return;
    var btn = form.querySelector('.b2b-lead__submit');
    btn.disabled = true;
    btn.textContent = 'Invio in corso…';

    var tipo = form.querySelector('input[name="tipo"]:checked').value;
    var nome = form.nome.value.trim();
    var parti = nome.split(/\s+/);
    var email = form.email.value.trim();
    var props = {
      b2b_tipo: TIPI[tipo],
      b2b_attivita: form.attivita.value.trim(),
      b2b_citta: form.citta.value.trim(),
      b2b_telefono: form.telefono.value.trim(),
      b2b_dimensione: sizeSelect.value || '',
      b2b_messaggio: form.messaggio.value.trim(),
      b2b_novita: form.marketing.checked ? 'Sì' : 'No',
      b2b_pagina: window.location.pathname,
      b2b_data: new Date().toISOString()
    };
    var attrs = { email: email, first_name: parti[0], organization: props.b2b_attivita, location: { city: props.b2b_citta }, properties: props };
    if (parti.length > 1) attrs.last_name = parti.slice(1).join(' ');

    klaviyoPost('profiles', { data: { type: 'profile', attributes: attrs } })
      .then(function () {
        return klaviyoPost('events', { data: { type: 'event', attributes: { properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Richiesta professionisti' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } } } } });
      })
      .then(function () {
        if (!form.marketing.checked || !LIST) return null;
        return klaviyoPost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Pagina professionisti',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: LIST } } } } }).catch(function () { return null; });
      })
      .then(function () {
        track('generate_lead', { business_type: tipo, business_size: props.b2b_dimensione });
        root.querySelector('[data-b2b-nome]').textContent = ', ' + parti[0];
        form.hidden = true;
        thanks.hidden = false;
        thanks.focus();
        thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Richiedi la proposta';
        mostraErrore("Non siamo riusciti a inviare la richiesta. Riprova tra un momento, oppure scrivici a info@ischiaspaeh.it.");
      });
  });
})();
